import React, { FC } from 'react';
import { Alert, DropdownMenu, Icon, IconButton } from '@kontentino/ui';
import UserPermissionGate from 'components/UserPermissionGate';
import { STATUS } from '@kontentino/kontentino-constants/Posts';
import { getPostFooterInfoMessage } from 'app/modules/posts/modules/detail/utils/getPostFooterInfoMessage';
import { UserPermission } from 'constants/userPermission';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { useTranslation } from 'react-i18next';

type Props = {
  status: number;
  onRespondToApprovalRequest: (
    action: 'approve' | 'rework',
    type: 'client' | 'internal',
  ) => void;
};

const ApprovalInfoAlert: FC<Props> = ({
  status,
  onRespondToApprovalRequest,
}) => {
  const { t } = useTranslation();
  return (
    <div className="tw-m-2">
      <Alert
        variant="info"
        className="tw-relative tw-inline-flex tw-w-full tw-items-center tw-justify-between "
      >
        <div className="tw-inline-flex tw-w-full">
          <span className="tw-inline-flex tw-w-full tw-pr-2">
            {getPostFooterInfoMessage({
              status,
              t,
            })}
          </span>
          {status === STATUS.AT_CLIENT && (
            <UserPermissionGate
              exact={false}
              scopes={[
                UserPermission.POST_CLIENT_APPROVE,
                UserPermission.POST_INTERNAL_APPROVE,
              ]}
            >
              <DropdownMenu.Root>
                <DropdownMenu.Trigger>
                  <IconButton
                    variant="plain"
                    className="tw-absolute tw-right-4"
                    icon={
                      <Icon
                        icon={faEllipsisV}
                        className="tw-cursor-pointer tw-text-grayscale-90 "
                        size={'md'}
                        withoutBoundary
                      />
                    }
                  />
                </DropdownMenu.Trigger>
                <DropdownMenu.Content>
                  <UserPermissionGate
                    scopes={UserPermission.POST_CLIENT_APPROVE}
                  >
                    <DropdownMenu.Item
                      onSelect={() =>
                        onRespondToApprovalRequest('approve', 'client')
                      }
                    >
                      {t('commentsWorkflowActions.clientApprove')}
                    </DropdownMenu.Item>
                  </UserPermissionGate>
                  <UserPermissionGate
                    scopes={UserPermission.POST_INTERNAL_APPROVE}
                  >
                    <DropdownMenu.Item
                      onSelect={() =>
                        onRespondToApprovalRequest('rework', 'internal')
                      }
                    >
                      {t('commentsWorkflowActions.internallyReject')}
                    </DropdownMenu.Item>
                  </UserPermissionGate>
                </DropdownMenu.Content>
              </DropdownMenu.Root>
            </UserPermissionGate>
          )}
        </div>
      </Alert>
    </div>
  );
};

export default ApprovalInfoAlert;
